import { z } from 'zod';

export const nookIdSchema = z
  .string({
    required_error: 'A nook name is required',
  })
  .toLowerCase()
  .trim()
  .min(1, 'A nook name must be at least 1 character long')
  .max(32, 'A nook name must be at most 32 characters long')
  .regex(
    /^[a-z0-9-_]+$/,
    'A nook name can only contain lowercase letters, numbers, hyphens, and underscores.'
  );

export const passwordSchema = z
  .string({
    required_error: 'A password is required for private nooks.',
  })
  .trim()
  .min(8, 'Password must be at least 8 characters long');

export const tokenSchema = z.string().uuid({ message: 'Invalid UUID' });

export const versionSchema = z.coerce.number().positive().int({
  message: 'Invalid version',
});

export const contentSchema = z.string({ message: 'Invalid content' });

export const authorSchema = z.string({ message: 'Invalid author name' });

export const secretSchema = z.string({ message: 'Invalid secret' });

export const articleIdSchema = z.coerce.number().positive().int({
  message: 'Invalid article id',
});

export const themeSchema = z.enum(['chenook-light', 'chenook-dark']);
